import React from 'react'
import { Link } from 'gatsby'
import SEO from '~/components/seo'
import ProductListing from '~/components/ProductListing'
import ProductBanner from '~/components/ProductsBanner'


const Products = () => (
  <>
    <SEO title="Products" keywords={[`gatsby`, `application`, `react`]} />
    <ProductBanner />
  <ProductListing />

  </>
)

export default Products
